import { AGENT_MANAGER_MODULE } from '@amg/config';
import { AUTOGRAMMETRY_MODULE } from '@atg/config';
import { BRAZE_CAMPAIGNS_MODULE } from '@bzc/config';
import { CONFIG_MANAGER_MODULE } from '@cfm/config';
import { DOCUMENTS_REVIEW_MODULE } from '@dcr/config';
import { FEES_MODULE } from '@fee/config';
import { KNOWLEDGE_BASE_MODULE } from '@kb/config';
import { MLOPS_MANAGER_MODULE } from '@mlm/config';
import { SDUI_ADMIN_MODULE } from '@sda/config';
import { SERVICE_HISTORY_REVIEW_MODULE } from '@shr/config';
import { SERVICE_INTERVALS_CATALOG_MODULE } from '@sic/config';
import { SELLER_MANAGER_MODULE } from '@slm/config';
import type { Module } from '@utils/model';
import { WORKFLOW_MODULE } from '@wfl/config';

export const MODULES: Module[] = [
	AGENT_MANAGER_MODULE,
	SELLER_MANAGER_MODULE,
	BRAZE_CAMPAIGNS_MODULE,
	CONFIG_MANAGER_MODULE,
	MLOPS_MANAGER_MODULE,
	AUTOGRAMMETRY_MODULE,
	SDUI_ADMIN_MODULE,
	WORKFLOW_MODULE,
	KNOWLEDGE_BASE_MODULE,
	FEES_MODULE,
	DOCUMENTS_REVIEW_MODULE,
	SERVICE_INTERVALS_CATALOG_MODULE,
	SERVICE_HISTORY_REVIEW_MODULE,
];
